// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_65N-Z","content":"index_content_QTqz1","textPrefix":"index_textPrefix_XroDU"};